export default "__VITE_ASSET__d378e7ed__"